import { Component, Input, OnChanges } from '@angular/core';
import { FileService } from 'src/app/core/services/file.service';

@Component({
  selector: 'app-custom-image',
  templateUrl: './custom-image.component.html',
  styleUrls: ['./custom-image.component.scss'],
})
export class CustomImageComponent implements OnChanges {
  @Input({ required: true }) imgId = '';
  @Input({ required: true }) alt = '';

  @Input() styleClass = '';
  @Input() imageClass = '';
  @Input() class = '';
  imageLoader = true;

  constructor(public fileService: FileService) {}

  ngOnChanges() {
    if (this.fileService.isYoutubeUrl(this.imgId)) {
      const id = this.fileService.getYoutubeId(this.imgId);
      this.imgId = this.fileService.getThumbnailYoutube(id);
    } else if (this.fileService.isVideoUrl(this.imgId)) {
      this.imgId = this.fileService.convertWebmToWebp(this.imgId);
    } else {
      this.imgId = this.fileService.getThumbnailWebp(this.imgId);
    }
  }

  onImageError() {
    this.imageLoader = false;
    this.imgId = 'assets/imgs/default/image.webp';
  }

  onImageLoad() {
    this.imageLoader = false;
  }
}
